<template>
  <section :class="{_animated: animated}"
           class="first-section container">
    <div class="first-section__content  container-inner">
      <div :class="selectorHeader"
           class="first-section__header">
        <MainLogo class="first-section__logo"/>

        <div class="d-flex ml-auto">
          <router-link-modified :to="{name: 'for-employers'}"
                                class="first-section__find-employees base-btn base-btn--blue mr-3">
            {{ $tHeader('find_employees') }}
          </router-link-modified>
          <router-link-modified :to="{name: 'find-vacancy'}"
                                class="first-section__find-work  base-btn  base-btn--green ">
            {{ $tHeader('Find vacancy') }}
          </router-link-modified>
        </div>

        <button type="button"
                key="mob-menu"
                @click.prevent="isMobMenuOpen = !isMobMenuOpen"
                :class="isMobMenuOpen ? '_open' : null"
                class="first-section__menu-btn  base-btn  d-none  d-sm-inline-flex">
          <transition name="fade">
            <BaseSvg v-if="isMobMenuOpen"
                     key="1"
                     name="ico-close"
                     width="2.1rem"
                     height="1.4rem"/>
            <BaseSvg v-else
                     key="2"
                     name="ico-burger"
                     width="2.1rem"
                     height="1.4rem"/>
          </transition>
        </button>

        <transition name="fade">
          <MobMenu v-if="isMobMenuOpen"
                   @close="isMobMenuOpen = false"
                   class="first-section__mob-menu"/>
        </transition>
      </div>
      <div ref="main" class="first-section__main">
        <h1 class="first-section__title">{{ title }}</h1>
        <div class="first-section__row">
          <div class="first-section__items">
            <template v-for="(item, index) in fullData.previewButtons">
              <router-link-modified :key="item.id"
                                    :to="getUrl(item.url)"
                                    ref="items"
                                    :style="animated ? null : getItemStyle(itemsPositions[index])"
                                    class="first-section__item">
                <div class="first-section__item-ico-wrap">
                  <div :style="`background-image: url(${item.icon_white})`"
                       class="first-section__item-ico"></div>
                </div>
                <div class="first-section__item-name">
                  {{ item.title }}
                </div>
              </router-link-modified>
            </template>
          </div>
          <div ref="box"
               class="first-section__animation-wrap">
            <Lottie :options="animationOptions"
                    :animationDataLoad="animationDataLoad"
                    :height="400"
                    :width="400"
                    @animCreated="handleAnimation"
                    class="first-section__animation"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import MainLogo from '@/components/MainLogo'
  import MobMenu from '@/components/MobMenu'
  import formatClientLink from '@/helpers/formatClientLink'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'

  const Lottie = () => import(
    /* webpackChunkName: "lottie" */ '@/components/Lottie'
    );

  const animationDataLoad = () => import(
    /* webpackChunkName: "lottie" */ '@/assets/lottie/lf30_avtzgfut.json'
    );

  export default {
    name: 'HomePageFirstSection',
    mixins: [windowSizeMixin],
    components: {
      MainLogo,
      MobMenu,
      Lottie
    },
    props: {
      fullData: Object,
      title: String,
    },
    data() {
      return {
        isMobMenuOpen: false,
        scrollPosition: 0,
        scrollPositionOld: 0,

        animation: null,
        animated: false,
        animationDataLoad,
        itemsPositions: []
      }
    },
    computed: {
      selectorHeader() {
        if (this.scrollPosition > 5) {
          return '_fixed'
        }

        return null
      },
      mobileVersion() {
        return this.windowSizeMixin.width <= WINDOW_SIZE_SM
      },
      animationOptions() {
        return {
          loop: false
        }
      },
    },
    methods: {
      updateScroll() {
        this.scrollPositionOld = this.scrollPosition
        this.scrollPosition = window.scrollY
      },
      handleAnimation(anim) {
        this.animation = anim;

        let options = {
          root: document.body,
          rootMargin: '0px',
          threshold: 0.5
        }

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.observer.unobserve(entry.target)
              this.runAnimation()
            }
          });
        }, options);

        this.observer.observe(this.$refs.main)
      },
      runAnimation() {
        this.animation.play();
        this.animated = true
      },
      formatClientLink,

      setItemsPositions() {
        const boxCenter = getElementCenter(this.$refs.box)
        const positions = []

        this.$refs.items.forEach(item => {
          const itemCenter = getElementCenter(item.$el)

          positions.push({
            x: boxCenter.x - itemCenter.x,
            y: boxCenter.y - itemCenter.y,
          })
        })

        this.itemsPositions = positions
      },
      getItemStyle(position) {
        if (!position) return null

        const y = this.mobileVersion ? position.y - 50 : position.y - 100

        return {
          transform: `translate(${position.x}px, ${y}px)`
        }
      },
      getUrl(url) {
        if (!url || url === '#') return null
        return formatClientLink(url)
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll)
      this.setItemsPositions()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.updateScroll)
    }
  }


  function getElementCenter(el) {
    const rect = el.getBoundingClientRect()

    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    }
  }
</script>

<style lang="less">

</style>
